var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "grouped-search",
      style: { maxWidth: _vm.normalizedMaxWidth }
    },
    [
      _c(
        "v-input",
        {
          ref: "input",
          attrs: {
            value: _vm.validationValue,
            rules: _vm.rules,
            "error-messages": _vm.errorMessages,
            "hide-details": !_vm.showDetails,
            disabled: _vm.disabled,
            loading: _vm.loading
          }
        },
        [
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scroll-y-transition",
                "max-width": _vm.normalizedMenuMaxWidth,
                "min-width": _vm.computedMenuMinWidth,
                "min-height": "auto",
                "offset-y": "",
                "content-class": "grouped-search__menu  rounded-xs",
                disabled: _vm.disabled
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _vm._t(
                          "activator",
                          [
                            _c(
                              "div",
                              { staticClass: "grouped-search__select" },
                              [
                                _vm.label
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "text-sm",
                                        class: {
                                          "grouped-search__label--disabled":
                                            _vm.disabled
                                        }
                                      },
                                      [_vm._v(" " + _vm._s(_vm.label) + " ")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        ref: "activator",
                                        staticClass:
                                          "grouped-search__input-container rounded-xs",
                                        class: {
                                          "grouped-search__input-container--active":
                                            _vm.show,
                                          "grouped-search__input-container--disabled":
                                            _vm.disabled
                                        }
                                      },
                                      "div",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("SelectedItemsDisplay", {
                                      attrs: {
                                        selectedItemsValues:
                                          _vm.selectedItemsValues,
                                        "default-text": _vm.selectionPlaceholder
                                      }
                                    }),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "grouped-search__icon",
                                        class: {
                                          "grouped-search__icon--active":
                                            _vm.show
                                        }
                                      },
                                      [_vm._v(" mdi-chevron-down ")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          { on: on, attrs: attrs }
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              ),
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c(
                "div",
                { staticClass: "grouped-search__modal bg-white" },
                [
                  _c("v-text-field", {
                    ref: "searchField",
                    staticClass: "new-ux",
                    attrs: {
                      placeholder: _vm.placeholder,
                      outlined: "",
                      autofocus: "",
                      disabled: _vm.isSearchDisabled
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  }),
                  _vm.showClearSelectedItems
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-primary text-xs text-underline text-bold text-right hover",
                          on: { click: _vm.clearSelectedItems }
                        },
                        [_vm._v(" Limpar seleção ")]
                      )
                    : _vm._e(),
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "full-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              color: "primary",
                              indeterminate: "",
                              size: "40"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "grouped-search__group-items" },
                        [
                          _vm._l(_vm.groupList, function(group) {
                            return _c("div", { key: group.id }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grouped-search__group-item bg-gray-2 rounded-xs",
                                  class: {
                                    "grouped-search__group-item--disabled":
                                      !group.hasItem &&
                                      !_vm.selectableLeafGroups
                                  }
                                },
                                [
                                  _vm.isLeafSelectable(group)
                                    ? _c("v-checkbox", {
                                        staticClass: "m-0 p-0",
                                        attrs: {
                                          disabled: _vm.isItemDisabled(
                                            group.id
                                          ),
                                          value: group.id,
                                          label: group.value,
                                          multiple: "",
                                          "hide-details": "",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.selectedItems,
                                          callback: function($$v) {
                                            _vm.selectedItems = $$v
                                          },
                                          expression: "selectedItems"
                                        }
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "grouped-search__group-toggle",
                                          class: {
                                            "grouped-search__group-toggle--disabled":
                                              !group.hasItem || _vm.disabled
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleGroupLabelClick(
                                                group
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-simple-checkbox", {
                                            staticClass: "m-0 p-0",
                                            attrs: {
                                              value: _vm.selectedGroups.includes(
                                                group.id
                                              ),
                                              indeterminate: _vm.isGroupIndeterminate(
                                                group.id
                                              ),
                                              disabled:
                                                !group.hasItem || _vm.disabled,
                                              ripple: false,
                                              color: "primary"
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.toggleGroupSelection(
                                                  {
                                                    groupId: group.id,
                                                    inputValue: $event
                                                  }
                                                )
                                              }
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "grouped-search__group-label"
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(group.value) + " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                  !_vm.isLeafSelectable(group)
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled:
                                              !group.hasItem || _vm.disabled,
                                            icon: "",
                                            small: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openCloseTeam(group.id)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              class: _vm.getGroupItemClasses(
                                                group.id
                                              )
                                            },
                                            [_vm._v(" mdi-chevron-down ")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.openedGroups.includes(group.id)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grouped-search__list-items pl-8"
                                    },
                                    _vm._l(group.items, function(item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: item && item.id ? item.id : index
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "m-0 p-0",
                                            attrs: {
                                              disabled: _vm.isItemDisabled(
                                                item.id
                                              ),
                                              value: item.id,
                                              label: String(item[_vm.keyItem]),
                                              multiple: "",
                                              "hide-details": "",
                                              color: "primary"
                                            },
                                            model: {
                                              value: _vm.selectedItems,
                                              callback: function($$v) {
                                                _vm.selectedItems = $$v
                                              },
                                              expression: "selectedItems"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ])
                          }),
                          _vm.isEmptyList
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-sm text-center text-color-900"
                                },
                                [_vm._v(" Nenhum item encontrado. ")]
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                  _vm.hasFooter
                    ? _c(
                        "div",
                        { staticClass: "grouped-search__footer" },
                        [_vm._t("footer")],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }